import { Controller } from "stimulus"
import RequestQueue from 'classes/RequestQueue';
import _ from 'lodash';
import DefaultCC from '../images/dividend/ic_cc.svg';
import AmexCC from '../images/dividend/ic_cc_amex.svg';
import VisaCC from '../images/dividend/ic_cc_visa.svg';
import DiscoverCC from '../images/dividend/ic_cc_discover.svg';
import McCC from '../images/dividend/ic_cc_mastercard.svg';

const updateTextResult = (element, data) => {
  element.classList.remove('t-text-mitre-gray-300');
  element.innerText = data;
}

const updateAutoRenewalExpirationTextResult = (element, data) => {
  let toggleValue = element.closest('.m-card-field-container-row').querySelector('[data-toggle-target="toggle"]').dataset.toggleStateValue;
  let date = new Date(data);
  date.setTime(date.getTime() + date.getTimezoneOffset()*60*1000);
  let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
  let month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
  let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
  element.innerText = `${toggleValue == 'ON' ? 'Renewing' : 'Expiring'} on ${month} ${day}, ${year}`;
}

const updateToggleResult = (element, data) => {
  if(_.isNull(data)) return;
  if (data) {
    element.dataset.toggleStateValue = 'ON';
  } else {
    element.dataset.toggleStateValue = 'OFF';
  }
}

const CC_IMAGE_MAPPING = {
  visa: VisaCC,
  mastercard: McCC,
  american_express: AmexCC,
  discover: DiscoverCC,
  default: DefaultCC
}

const updateCcImageResult = (element, data) => {
  const parameterizedCc = data.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "_");
  const imageSrc = CC_IMAGE_MAPPING[parameterizedCc] || CC_IMAGE_MAPPING['default'];
  element.firstElementChild.src = imageSrc;
}

const updateCardFourDigitsResult = (element, data) => {
  element.innerHTML = `**** **** **** ${data}`;
}

const updateCardExpirationBadgeResult = (element, data) => {
  let date = new Date(data);
  let today = new Date();
  let expireSoon = date.getMonth() - today.getMonth() + 12 * (date.getFullYear() - today.getFullYear()) <= 2;
  expireSoon ? element.classList.remove('t-hidden') : element.classList.add('t-hidden');
}

const updateAutoRenewalExpirationBadgeResult = (element, data) => {
  let toggleValue = element.closest('.m-card-field-container-row').querySelector('[data-toggle-target="toggle"]').dataset.toggleStateValue;
  let date = new Date(data);
  let today = new Date();
  let remainingDays = parseInt((date.getTime() - today.getTime()) / (1000 * 3600 * 24));
  element.innerHTML = (remainingDays <= 30 && toggleValue == 'OFF') ? (remainingDays <= 0 ? 'membership expired' : `expiring in ${remainingDays} days`) : '';
}

const updateCardExpirationResult = (element, data) => {
  let date = new Date(data);
  date.setTime(date.getTime() + date.getTimezoneOffset()*60*1000);
  let year = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(date);
  let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
  element.innerText = `Exp Date: ${month}/${year}`;
}

const CARD_FIELD_METHODS = {
  text: updateTextResult,
  textAutoRenewalExpiration: updateAutoRenewalExpirationTextResult,
  toggle: updateToggleResult,
  ccImage: updateCcImageResult,
  cardFourDigits: updateCardFourDigitsResult,
  cardExpiration: updateCardExpirationResult,
  cardExpirationBadge: updateCardExpirationBadgeResult,
  autoRenewalExpirationBadge: updateAutoRenewalExpirationBadgeResult,
}

class CardFieldController extends Controller {
  static targets = [
    'display',
    'successMessage'
  ]
  static values = {
    requestUrl: String,
    requestParam: Object,
    placeholder: String
  }

  connect() {
    this.init();
  }

  init = async () => {
    if (!(this.requestUrlValue && this.requestParamValue)) return;
    this.displayTargets.map(displayTarget => {
      displayTarget.dataset.dataState = 'loading';
    });
    const response = await RequestQueue.addToQueue({
      url: this.requestUrlValue,
      method: 'get',
      params: this.requestParamValue
    });
    if (response.status == 200 && response.data) {
      this.__updateDisplayResults(response.data);
    } else {
      this.__displayEmptyResult();
      console.log(`error occurred at ${this.requestUrlValue} API`);
    }
  }

  updateCreditCardInfo = () => {
    this.init();
    this.__showUpdateMessage();
  }

  __updateDisplayResults = (data = null) => {
    this.displayTargets.map(displayTarget => {
      const displayData = data[displayTarget.dataset.fieldKey];
      if(_.isNull(displayData) || typeof(displayData) == 'string' && displayData.replace(/\s/g, '') == '') {
        this.__displayEmptyResult(displayTarget);
        return;
      }
      if (displayTarget.dataset.noFade == 'true') {
        CARD_FIELD_METHODS[displayTarget.dataset.cardFieldType].call(this, displayTarget, displayData);
        displayTarget.dataset.dataState = 'complete';
      } else {
        displayTarget.style.opacity = 0;
        setTimeout(() => {
          CARD_FIELD_METHODS[displayTarget.dataset.cardFieldType].call(this, displayTarget, displayData);
          displayTarget.style.opacity = 1;
          displayTarget.dataset.dataState = 'complete';
        }, 250);
      }
    });
  }

  __displayEmptyResult = (displayTarget = null) => {
    const replaceDisplayTarget = (displayTarget) => {
      displayTarget.classList.add('t-text-mitre-gray-300');
      displayTarget.innerHTML = this.hasPlaceholderValue ? this.placeholderValue : '';
      displayTarget.dataset.dataState = 'complete';
    }
    if(displayTarget) {
      replaceDisplayTarget(displayTarget);
    } else {
      this.displayTargets.map(displayTarget => replaceDisplayTarget(displayTarget));
    }
  }

  __showUpdateMessage = () => {
    this.successMessageTarget.classList.remove('t-hidden');
  }
}

export default CardFieldController;
